// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('InventoryService', InventoryService);

  InventoryService.$inject = [
    'TourInventoryService',
    'TransportationInventoryService',
    'HotelInventoryService',
  ];

  function InventoryService(
    TourInventoryService,
    TransportationInventoryService,
    HotelInventoryService
  ) {
    var service = {
      getInventory: getInventory,
    };

    return service;

    ////////////////

    function getInventory(productType, filterCriteria) {
      var inventory;
      switch (productType) {
        case 'tour':
          inventory = TourInventoryService.getTourInventory(filterCriteria);
          break;
        case 'transportation':
          inventory = TransportationInventoryService.getTransportationInventory(filterCriteria);
          break;
        case 'hotel':
          inventory = HotelInventoryService.getHotelInventory(filterCriteria);
          break;
      }

      return inventory;
    }
  }
})();
